import styled from 'styled-components'
import { Color } from '../../theme/color'

const BannerContainer = styled.div`
  overflow: hidden;
  width: 100%;
  border-bottom-right-radius: 32px;
  border-bottom-left-radius: 32px;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const HomeBannerContainer = styled(BannerContainer)`
  aspect-ratio: 1/1.12;
  cursor: pointer;
`

export const DetailBannerContainer = styled(BannerContainer)`
  aspect-ratio: 1/0.9;
  .swiper,
  .swiper-slide {
    position: relative;
    height: 100%;
  }
  .swiper-pagination {
    display: flex;
    justify-content: center;
    gap: 4px;
    bottom: 8px;
    height: 10px;
    transform: none;
    .swiper-pagination-bullet {
      opacity: 1;
      width: 10px;
      height: 10px;
      margin: 0;
      border: 1px solid ${Color.gray_4};
      background-color: ${Color.white};
      &.swiper-pagination-bullet-active {
        border: none;
        background-color: ${Color.black};
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
